export function PersonXFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M10.605 12c2 0 5-2.462 5-5.5s-2.238-5.5-5-5.5c-2.761 0-5 2.462-5 5.5s3 5.5 5 5.5z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.187 13a5.99 5.99 0 00-5.846 4.69l-.302 1.359A1.603 1.603 0 004.604 21h7.924a6 6 0 10-.05-7.943 6.5 6.5 0 00-.86-.057h-2.43zm10.641 1.172a1 1 0 010 1.414L18.414 17l1.414 1.414a1 1 0 11-1.414 1.414L17 18.414l-1.414 1.414a1 1 0 01-1.414-1.414L15.586 17l-1.414-1.414a1 1 0 111.414-1.414L17 15.586l1.414-1.414a1 1 0 011.414 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
